import './Basket.css';
import BasketItem from "./BasketItem/BasketItem.jsx";
import {clearCart} from "../../CartHandler.js";
import {useBasket} from "../../context/BasketContext/BasketContext.jsx";
import {useNotification} from "../../context/NotificationContext/NotificationContext.jsx";
import {generateCheckoutLink} from "../../CheckoutHandler.js";
import {Helmet} from "react-helmet-async";

export default function Basket({basket}) {
    const { basketVersion, bumpBasketVersion } = useBasket()

    const {displayNotification,setDisplayNotification}=useNotification();

    const order = async()=>{

        const url = await generateCheckoutLink();
        window.location.href = url.url;

    }

    const calculateTotalAmount = () => {
        let tempAmount = 0;
        basket.forEach(item => {
            tempAmount += item.quantity;
        })
        return tempAmount;
    }

    const calculateTotalPrice = () => {
        let tempAmount = 0;
        basket.forEach(item => {
            tempAmount += item.quantity * item.item.price;
        });
        return parseFloat(tempAmount).toFixed(2); // Ensures only 2 decimal places
    };

    const handleClearBasket = async () => {
        await clearCart();
        bumpBasketVersion()
        setDisplayNotification({type:'message',message:'Koszyk został pomyślnie opróżniony!'})
    };

    return <div id="basket">
        <Helmet>
            <title>Koszyk | Lumestore</title>
            <meta name="description" content="Twój koszyk w Lumestore." />
            <meta name="robots" content="noindex,follow" />
            <link rel="canonical" href="https://lumestore.pl/koszyk" />
            <meta property="og:url" content="https://lumestore.pl/koszyk" />
            <meta property="og:title" content="Koszyk | Lumestore" />
            <meta property="og:description" content="Twój koszyk w Lumestore." />
        </Helmet>
        <div id='basket-left'>
            <div id='basket-left-top'>
                <div id='basket-labels-container'>
                    <span id='basket-label-1'>Koszyk</span>
                    <span id='basket-label-2'>{`${calculateTotalAmount()} ${calculateTotalAmount() === 1 ? 'produkt' : 'produkty'} `}</span>
                </div>
                <div id='clear-basket-bttn'>
                    <div id='clear-basket-image'>
                        <img loading="lazy" src='/images/trash-icon.webp' alt="" />

                    </div>
                    <div id='clear-basket-label' onClick={handleClearBasket}>Opróżnij koszyk</div>
                </div>
            </div>
            <div id='basket-left-items'>
                {basket.length > 0 && basket.map((item, index) => {
                    return <BasketItem key={index} item={item}/>
                })}
            </div>
        </div>
        <div id='basket-right'>
            <div id='basket-sum'>
                <span id='basket-sum-label-1'>Do zapłaty</span>
                <span id='basket-sum-label-2'>{calculateTotalPrice()} zł</span>
            </div>
            {basket.length!==0 ? <div id='basket-order-bttn' onClick={()=>{order()}}>Zamów</div> : <div id='basket-order-bttn-disabled'>Zamów</div> }
        </div>
    </div>;
}
